import { useParams } from "react-router-dom";
import { useAuthors } from "@/hooks/use-sheets-data";
import { useAnalytics } from "@/hooks/use-analytics";

export function Author() {
  const { slug } = useParams();
  const { data: authors, isLoading } = useAuthors();
  useAnalytics();

  console.log('Debug - Author page:', {
    slug,
    authorsCount: authors?.length,
    allAuthors: authors?.map(a => ({
      name: a.name,
      slug: a.slug,
      picture: a.picture,
      id: a.id
    })),
  });

  const author = authors?.find((a) => a.slug === slug);
  
  console.log('Debug - Found author:', {
    authorFound: !!author,
    authorDetails: {
      name: author?.name,
      slug: author?.slug,
      picture: author?.picture,
      id: author?.id,
      bio: author?.bio
    }
  });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <p className="text-xl text-muted-foreground">Loading author...</p>
      </div>
    );
  }

  if (!author) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <p className="text-xl text-muted-foreground">Author not found</p>
      </div>
    );
  }

  return (
    <div className="-mx-6 -mt-6 min-h-[calc(100vh-4rem)]">
      <div className="border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="container py-8">
          <div className="flex gap-8">
            <div className="w-48 h-48 relative bg-muted rounded-lg overflow-hidden">
              {author.picture ? (
                <img
                  src={author.picture}
                  alt={author.name}
                  className="object-cover w-full h-full"
                />
              ) : (
                <div className="absolute inset-0 flex items-center justify-center text-muted-foreground">
                  No image
                </div>
              )}
            </div>
            <div className="flex-1">
              <h1 className="text-3xl font-bold mb-2">{author.name}</h1>
              <p className="text-muted-foreground whitespace-pre-wrap">
                {author.bio}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}